import React, { useEffect, useState } from "react";
import { getAPI, putAPI } from "../../../config/api/apiConfig";
import { useSelector } from "react-redux";
import { List, Spin, ConfigProvider, Alert, Modal, Form, Input, Button, message } from "antd";
import styled from "styled-components";

const StyledListItem = styled(List.Item)`
  cursor: pointer;
  &:hover {
    .ant-list-item-meta-title {
      color: green;
    }
  }
`;

const StyledInput = styled(Input)`
  &.ant-input[disabled] {
    color: black;
  }
`;

const OrganisationList = () => {
  const token = useSelector((state) => state.authenticate.userToken);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedOrganisation, setSelectedOrganisation] = useState(null);
  const [form] = Form.useForm();

  const getOrganisations = async () => {
    setLoading(true);
    try {
      const response = await getAPI(`get-organisations`, token);
      const { data } = response.data;
      setData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrganisations();
  }, [token]);

  const showModal = (organisation) => {
    setSelectedOrganisation(organisation);
    setModalVisible(true);
    form.setFieldsValue(organisation);
  };

  const handleUpdate = async (values) => {
    try {
      const updatedOrganisation = await putAPI(`update-organisation/${selectedOrganisation.id}`, values, token);
      message.success("Organization updated successfully");
      setModalVisible(false);
      // Refresh the data
      const updatedData = data.map(org => (org.id === selectedOrganisation.id ? { ...org, ...values } : org));
      setData(updatedData);
    } catch (error) {
      message.error("Failed to update organization");
    }
  };

  return (
    <div className="demo-infinite-container">
      {data.length !== 0 ? (
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#1A472B",
            },
          }}
        >
          <List
            dataSource={data}
            renderItem={(item) => (
              <StyledListItem key={item.id} onClick={() => showModal(item)}>
                <List.Item.Meta title={<a>{item.organisationName}</a>} />
              </StyledListItem>
            )}
          >
            {loading && (
              <div className="demo-loading-container">
                <Spin />
              </div>
            )}
          </List>

          {selectedOrganisation && (
            <Modal
              title={`Organisation Details: ${selectedOrganisation.organisationName}`}
              visible={modalVisible}
              onCancel={() => setModalVisible(false)}
              footer={null}
            >
              <Form form={form} layout="vertical" onFinish={handleUpdate}>
                <Form.Item label="Username" name="username">
                  <StyledInput disabled />
                </Form.Item>
                <Form.Item label="Organisation Name" name="organisationName">
                  <StyledInput disabled />
                </Form.Item>
                <Form.Item label="Role" name="role">
                  <StyledInput disabled />
                </Form.Item>
                <Form.Item label="Created By" name="createdBy">
                  <StyledInput disabled />
                </Form.Item>
                <Form.Item label="Created At" name="createdAt">
                  <StyledInput disabled />
                </Form.Item>
                <Form.Item label="Updated At" name="updatedAt">
                  <StyledInput disabled />
                </Form.Item>
                {/* <Form.Item>
                  <Button type="primary" htmlType="submit">Save</Button>
                </Form.Item> */}
              </Form>
            </Modal>
          )}
        </ConfigProvider>
      ) : (
        <Alert
          message="No Organisation"
          description="No Organisations added"
          className="alert"
          showIcon
        />
      )}
    </div>
  );
};

export default OrganisationList;
